import React from "react";
import img1 from "../img/A time and a space&&First Operator Chronicles---Interweaving of textured layers in Adobe Photoshop over curated, AI-generated visuals___2026-01[[1]].jpg"
export default function Machine_3_1() {
  return (
    <div className="panel-block">

      <div className="panel-container-left">
        <img
          loading="lazy"
          src={img1}
          alt="3.1 · FIRST OPERATOR CYCLE"
        />
      </div>

      <div className="panel-container-right">
        <h2>3.1 · FIRST OPERATOR CYCLE</h2>

      <p>
    The beginning of this cycle.
  </p>

  <p>
    Logs of the First Operator<br />
    as consciousness and Machine<br />
    began to overlap.
  </p>

  <p>
    Not mythology.<br />
    Not fiction.
  </p>

  <p>
    An account written<br />
    from within interference.
  </p>

  <p>
    The arc is incomplete.
  </p>

  <p>
    It always is.
  </p>
  <p><a target="_blank" rel="noreferrer" href="https://thevakztharimachine.substack.com/p/first-operator-chronicles-index">Read it here</a></p>
      </div>

    </div>
  );
}
